module.exports = __webpack_public_path__ + "img/zixun-recommend-2.cfe99854.png";